<div class="ingredientsAndMethod">
	<section class="ingredientsAndMethod-ingredientsSection">
		<ng-container *ngFor="let group of orderedIngredients; let i = index; trackBy: trackByGroupsFn">
			<header>
				<h2 *ngIf="i === 0">{{ group.heading }}</h2>
				<h3 *ngIf="i > 0">{{ group.heading }}</h3>
			</header>
			<ul class="ingredientsAndMethod-ingredientList">
				<li
					class="ingredientsAndMethod-ingredientItem"
					*ngFor="let ingredient of group.ingredients; trackBy: trackByIngredientsFn"
					[innerHTML]="ingredient.description | sentencecase"
				></li>
			</ul>
		</ng-container>
		<div class="ingredientsAndMethod-icons">
			<button
				*ngIf="enableAddToTrolley"
				class="ingredientsAndMethod-addToTrolley"
				cdxButton
				[startSlotActive]="true"
				(click)="addItemsToTrolley()"
			>
				<cdx-svg-icon start name="cart-default"></cdx-svg-icon>
				<span i18n="@@recipe-addItemsToTrolley">Add items to trolley</span>
			</button>
		</div>
	</section>
	<section class="ingredientsAndMethod-methodSection">
		<header>
			<h2 i18n="@@recipe-methodTitle">Method</h2>
		</header>
		<div class="ingredientsAndMethod-methodMarkdown" [innerHTML]="markdownData"></div>
		<recipe-contributor
			*ngIf="contributorName"
			[name]="contributorName"
			[town]="contributorTown"
			[link]="contributorLink"
		></recipe-contributor>
	</section>
</div>
